import React from 'react'

export const PaginationRoot = ({ children, className = '', size = 'is-small', align = 'is-left' }) => {
  return (
    <nav className={`pagination ${className} ${size} ${align} mx-auto`} role="navigation" aria-label="pagination">
      {children}
    </nav>
  )
}
